function heightAutomate() {
    var bodyHeight = $("body").height();
    var viewportHeight = $(window).height();
    var shudbe_bf_Height = $("body").height();
    // console.log(shudbe_bf_Height);
    /*153:height of div+footer*/
    var real_bf_Height = $("#sidebar").height();

    if (real_bf_Height < shudbe_bf_Height) {
        $("#sidebar").css({"height": shudbe_bf_Height});
    }
}

export default function () {
    $(function () {
        $('#birthdate').datetimepicker({
            locale: 'fr',
            format: 'DD/MM/YYYY',
            extraFormats: ['DD/MM/YYYY', 'DD/MM/YY']
        });

        heightAutomate();
    });
}



// WEBPACK FOOTER //
// ./src/assets/js/functions.js